export function getTotalPriceDishRejectOrder({
  priceUpdateOrder,
  outOfStockOrder,
  listTopping,
  itemDish,
}) {
  const { dish } = itemDish;
  const { discount_price: discountPrice, id: dishId } = dish;
  const {
    toppings: listToppingPrice = [],
    dishes: listDishPrice = [],
  } = priceUpdateOrder;

  const { toppings: listToppingOutOfStock = [] } = outOfStockOrder;

  // Get total price dish after change
  const dishChange = listDishPrice.find(dishItem => dishItem.dishId === dishId);
  const totalPriceDish = dishChange ? dishChange.price : discountPrice.value;

  // Get total price topping without out of stock and change price
  const totalPriceTopping = listTopping
    .filter(
      topping =>
        !listToppingOutOfStock
          .map(toppingOutOfStock => toppingOutOfStock.toppingId)
          .includes(topping.id),
    )
    .reduce((total, value) => {
      const toppingChangePrice = listToppingPrice.find(
        toppingChange => toppingChange.toppingId === value.id,
      );
      if (toppingChangePrice) {
        return total + toppingChangePrice.price * value.quantity;
      }
      return total + value.price * value.quantity;
    }, 0);

  return totalPriceDish + totalPriceTopping;
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/routines.js